import { HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { map, tap } from 'rxjs/operators';


interface CacheEntry<T> {
  body: T;
  headers: any;
  status: number;
  expires?: number;
}


@Injectable({ providedIn: 'root' })
export class HttpCacheService {

  private cache = new Map<string, CacheEntry<any>>();
  private readonly STORAGE_KEY = 'paf-http-cache';

  constructor() {
    this.restore();
  }

  get<T>(
    key: string,
    request$: Observable<HttpResponse<T>>,
    ttlMs = 30 * 60 * 1000 // 30 min
  ): Observable<T> {

    const entry = this.cache.get(key);

    if (entry && (!entry.expires || Date.now() < entry.expires)) {
      return of(entry.body as T);
    }

    return request$.pipe(
      tap(response => {
        const entry: CacheEntry<T> = {
          body: response.body as T,
          headers: response.headers,
          status: response.status,
          expires: Date.now() + ttlMs
        };

        this.cache.set(key, entry);
        this.persist();
      }),
      map(response => response.body as T)
    );
  }

  clear(key?: string) {
    key ? this.cache.delete(key) : this.cache.clear();
    this.persist();
  }

  // 🔽 Persistance
  private persist() {
    sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify([...this.cache]));
  }

  private restore() {
    const raw = sessionStorage.getItem(this.STORAGE_KEY);
    if (raw) {
      this.cache = new Map(JSON.parse(raw));
    }
  }

}

